import { gql } from 'graphql-request'

class CustomerQueries {
  getAll = gql`
    query getCustomers(
      $where: CustomerWhereInput
      $after: String
      $first: Int
      $orderBy: CustomerOrderByExtendedInput
    ) {
      customers(where: $where, after: $after, first: $first, orderBy: $orderBy) {
        id
        name
        nbClaimedPlaces
        nbRemainingLicenses
        nbExperiences
        createdAt
        adminEmail
        claimedPlaces {
          googlePlaceId
          name
          address
        }
        avatar {
          url
        }
        fallbackDescription
        fallbackActionText
        fallbackActionUrl
        fallbackImage {
          url
        }
      }
    }
  `

  getCustomer = gql`
    query GetCustomer($where: CustomerWhereUniqueInput!) {
      customer(where: $where) {
        id
        name
        nbClaimedPlaces
        nbRemainingLicenses
        nbExperiences
        totalLicenses
        createdAt
        adminEmail
        claimedPlaces {
          googlePlaceId
          name
          address
        }
        avatar {
          url
        }
        fallbackImage {
          url
        }
        fallbackDescription
        fallbackActionText
        fallbackActionUrl
      }
    }
  `
}

const customerQueries = new CustomerQueries()

export default customerQueries
